<template>
  <div class="time-line-dialog" v-if="value" @click.stop.self="handleClickMask">
    <div class="dialog-content">
      <div v-if="dialogDetails.textInfo" class="container1">{{dialogDetails.textInfo}}</div>
      <div v-if="dialogDetails.videoUrl" class="container">
        <video id="avi" x5-playsinline="true" playsinline="true" webkit-playsinline="true"  preload="load"  :src="dialogDetails.videoUrl" style="background-color: #000;max-height: 288px;width: 100%;" controls="controls">
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <div class="close-btn" @click="handleClose">
        关闭
    </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    dialogDetails: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
   watch:{
      dialogDetails(newvalue){
        console.log(newvalue,'sdsdsds')
        this.dialogDetails = newvalue
      }
    },
  methods: {
    handleClose() {
      // ModalHelper.beforeClose();
      if (document.getElementsByTagName('video')[0]) {
        let myplay = document.getElementsByTagName('video')[0]
        myplay.currentTime = 0;
        myplay.pause();
      }
      this.$emit("input", false)
    },
    handleClickMask() {
      if (this.closeOnClickModal) {
        this.handleClose()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.time-line-dialog {
  position: fixed;
  z-index: 999999999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #f9f9f9;
  background-image: linear-gradient(
        0deg,
        #f9f9f8 40%,
        rgba(255, 96, 78, 0.72) 210%
      ),
      linear-gradient(#f9f9f9, #f9f9f9);
  .dialog-content {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-blend-mode: normal, normal;
  }
  .container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 26px;
    letter-spacing: 1px;
    color: #585858;
    z-index: 10;
    background: #000;
  }
  .container1 {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    padding: 0 40px;
    overflow: auto;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 26px;
    letter-spacing: 1px;
    color: #585858;
    z-index: 10;
    box-sizing: border-box;
  }
  .close-btn {
    width: 95px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ff604e;
    border-radius: 3px;
    font-family: MicrosoftYaHei;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 12px;
    letter-spacing: 3px;
    color: #ffffff;
    margin: 20px auto 0;
  }
}
</style>